import { render, staticRenderFns } from "./UserProfileJumbo.vue?vue&type=template&id=a3c1dc32&scoped=true&"
import script from "./UserProfileJumbo.vue?vue&type=script&lang=js&"
export * from "./UserProfileJumbo.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileJumbo.vue?vue&type=style&index=0&id=a3c1dc32&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c1dc32",
  null
  
)

export default component.exports